/* eslint-disable camelcase */
import { call, put, select, cancelled, takeEvery } from 'redux-saga/effects'
import { selectUser } from './user'
import queryString from 'query-string'

import axios from 'axios'
import API from '../config'
import { get } from 'lodash-es'
import { normalize } from 'normalizr'
import { feedSection as feedSectionSchema, user as userSchema } from '../schemas'
import userAgentParser from '../util/userAgentParser'
import { receiveProfile } from './profile'
import { getHeaders } from './api'

const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const REQUEST_RETRIEVE_IMAGE_FIRST_ITEM = 'REQUEST_RETRIEVE_IMAGE_FIRST_ITEM'
export const RECEIVE_RETRIEVE_IMAGE_FIRST_ITEM = 'RECEIVE_RETRIEVE_IMAGE_FIRST_ITEM'

export const REQUEST_FEED_SECTIONS = 'REQUEST_FEED_SECTIONS'
export const RECEIVE_FEED_SECTIONS = 'RECEIVE_FEED_SECTIONS'

export const REQUEST_ADD_FEED_TO_SECTIONS_PROFILE = 'REQUEST_ADD_FEED_TO_SECTIONS_PROFILE'
export const RECEIVE_ADD_FEED_TO_SECTIONS_PROFILE = 'RECEIVE_ADD_FEED_TO_SECTIONS_PROFILE'

export const REQUEST_REMOVE_FEED_FROM_SECTIONS_PROFILE = 'REQUEST_REMOVE_FEED_FROM_SECTIONS_PROFILE'
export const RECEIVE_REMOVE_FEED_FROM_SECTIONS_PROFILE = 'RECEIVE_REMOVE_FEED_FROM_SECTIONS_PROFILE'

export const REQUEST_FEEDS_SAVED_TO_SECTIONS_PROFILE = 'REQUEST_FEEDS_SAVED_TO_SECTIONS_PROFILE'
export const RECEIVE_FEEDS_SAVED_TO_SECTIONS_PROFILE = 'RECEIVE_FEEDS_SAVED_TO_SECTIONS_PROFILE'

export const UPDATE_SORT_FEEDS_SECTIONS_PROFILE = 'UPDATE_SORT_FEEDS_SECTIONS_PROFILE'

export const REQUEST_ADD_FEED_TO_SECTIONS_FEEDER = 'REQUEST_ADD_FEED_TO_SECTIONS_FEEDER'
export const RECEIVE_ADD_FEED_TO_SECTIONS_FEEDER = 'RECEIVE_ADD_FEED_TO_SECTIONS_FEEDER'

export const REQUEST_REMOVE_FEED_FROM_SECTIONS_FEEDER = 'REQUEST_REMOVE_FEED_FROM_SECTIONS_FEEDER'
export const RECEIVE_REMOVE_FEED_FROM_SECTIONS_FEEDER = 'RECEIVE_REMOVE_FEED_FROM_SECTIONS_FEEDER'

export const REQUEST_FEEDS_SAVED_TO_SECTIONS_FEEDER = 'REQUEST_FEEDS_SAVED_TO_SECTIONS_FEEDER'
export const RECEIVE_FEEDS_SAVED_TO_SECTIONS_FEEDER = 'RECEIVE_FEEDS_SAVED_TO_SECTIONS_FEEDER'

export const REQUEST_SAVE_SECTION_FEEDS_ORDER = 'REQUEST_SAVE_SECTION_FEEDS_ORDER'
export const RECEIVE_SAVE_SECTION_FEEDS_ORDER = 'RECEIVE_SAVE_SECTION_FEEDS_ORDER'

export const REQUEST_SET_FEED_THUMBNAILS = 'REQUEST_SET_FEED_THUMBNAILS'
export const RECEIVE_SET_FEED_THUMBNAILS = 'RECEIVE_SET_FEED_THUMBNAILS'

export const REQUEST_SET_FEED_CHILDREN = 'REQUEST_SET_FEED_CHILDREN'
export const RECEIVE_SET_FEED_CHILDREN = 'RECEIVE_SET_FEED_CHILDREN'

export const REQUEST_SAVE_EDIT_NEW_SECTION = 'REQUEST_SAVE_EDIT_NEW_SECTION'
export const RECEIVE_SAVE_EDIT_NEW_SECTION = 'RECEIVE_SAVE_EDIT_NEW_SECTION'

export const REQUEST_CUSTOM_FEED_SECTIONS = 'REQUEST_CUSTOM_FEED_SECTIONS'
export const RECEIVE_CUSTOM_FEED_SECTIONS = 'RECEIVE_CUSTOM_FEED_SECTIONS'

export const REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTIONS = 'REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTIONS'
export const RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTIONS = 'RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTIONS'

export const REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTION = 'REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTION'
export const RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTION = 'RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTION'

export const REQUEST_ADD_FEED_TO_FEED_SECTION = 'REQUEST_ADD_FEED_TO_FEED_SECTION'
export const RECEIVE_ADD_FEED_TO_FEED_SECTION = 'RECEIVE_ADD_FEED_TO_FEED_SECTION'

export const REQUEST_REMOVE_FEED_TO_FEED_SECTION = 'REQUEST_REMOVE_FEED_TO_FEED_SECTION'
export const RECEIVE_REMOVE_FEED_FROM_FEED_SECTION = 'RECEIVE_REMOVE_FEED_FROM_FEED_SECTION'

export const requestFeedSections = payload => {
  return {
    type: REQUEST_FEED_SECTIONS,
    payload
  }
}

export const receiveFeedSections = data => {
  return {
    type: RECEIVE_FEED_SECTIONS,
    payload: {
      data
    }
  }
}

function* getFeedSections(action) {
  const url = rootApi + 'account/get-feed-sections'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const { userId } = payload
  const userAgentParsed = userAgentParser()
  const params = {
    device: userAgentParsed.device,
    home: 1
  }
  if (userId) {
    params.user_id = userId
  }

  try {
    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      params,
      cancelToken: source.token
    })
    if (get(response, 'status') === 200) {
      let normalizedData
      const { sections } = response.data

      if (userId) {
        normalizedData = normalize({ id: userId, feedSections: sections }, userSchema)
        yield put(receiveProfile(normalizedData))
        normalizedData = normalize(sections, [feedSectionSchema])
        yield put(receiveFeedSections(normalizedData))
      } else {
        sections.map(i => {
          i.home = 1
          return i
        })
        normalizedData = normalize(sections, [feedSectionSchema])
        yield put(receiveFeedSections(normalizedData))
      }
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getFeedSectionsSaga() {
  yield takeEvery(REQUEST_FEED_SECTIONS, getFeedSections)
}

export const requestAddFeedToSectionsProfile = payload => {
  return {
    type: REQUEST_ADD_FEED_TO_SECTIONS_PROFILE,
    payload
  }
}

export const receiveAddFeedToSectionsProfile = payload => {
  return {
    type: RECEIVE_ADD_FEED_TO_SECTIONS_PROFILE,
    payload
  }
}

function* addFeedToSectionsProfile(action) {
  const url = rootApi + 'account/add-to-my-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    yield call([axios, 'post'], url, params, {
      headers,
      cancelToken: source.token
    })
    yield put(receiveAddFeedToSectionsProfile(action.payload.item))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* addFeedToSectionsProfileSaga() {
  yield takeEvery(REQUEST_ADD_FEED_TO_SECTIONS_PROFILE, addFeedToSectionsProfile)
}

export const requestRemoveFeedFromSectionsProfile = payload => {
  return {
    type: REQUEST_REMOVE_FEED_FROM_SECTIONS_PROFILE,
    payload
  }
}

export const receiveRemoveFeedFromSectionsProfile = payload => {
  return {
    type: RECEIVE_REMOVE_FEED_FROM_SECTIONS_PROFILE,
    payload
  }
}

function* removeFeedFromSectionsProfile(action) {
  const url = rootApi + 'account/remove-from-my-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    yield call([axios, 'post'], url, params, {
      headers,
      cancelToken: source.token
    })
    yield put(receiveRemoveFeedFromSectionsProfile(action.payload.item))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* removeFeedFromSectionsProfileSaga() {
  yield takeEvery(REQUEST_REMOVE_FEED_FROM_SECTIONS_PROFILE, removeFeedFromSectionsProfile)
}

export const requestFeedsSavedToSectionsProfile = payload => {
  return {
    type: REQUEST_FEEDS_SAVED_TO_SECTIONS_PROFILE,
    payload
  }
}

export const receiveFeedsSavedToSectionsProfile = payload => {
  return {
    type: RECEIVE_FEEDS_SAVED_TO_SECTIONS_PROFILE,
    payload
  }
}

function* feedsSavedToSectionsProfile(action) {
  const url = rootApi + 'account/get-my-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    const response = yield call([axios, 'get'], url, {
      headers,
      params
    })
    const formattedFeedSections = response.data.feeds
      .reduce((acc, item) => {
        acc.push({
          text: item.name,
          to: '/custom-feed/' + item.id + '----' + item.name,
          id: item.id,
          position: item.position
        })
        return acc
      }, [])
      .sort((a, b) => (a.position > b.position ? 1 : -1))
    yield put(receiveFeedsSavedToSectionsProfile(formattedFeedSections))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* FeedsSavedToSectionsProfileSaga() {
  yield takeEvery(REQUEST_FEEDS_SAVED_TO_SECTIONS_PROFILE, feedsSavedToSectionsProfile)
}

export const requestAddFeedToSectionsFeeder = payload => {
  return {
    type: REQUEST_ADD_FEED_TO_SECTIONS_FEEDER,
    payload
  }
}

export const receiveAddFeedToSectionsFeeder = payload => {
  return {
    type: RECEIVE_ADD_FEED_TO_SECTIONS_FEEDER,
    payload
  }
}

function* addFeedToSectionsFeeder(action) {
  const url = rootApi + 'account/add-to-my-home-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    yield call([axios, 'post'], url, params, {
      headers,
      cancelToken: source.token
    })
    yield put(receiveAddFeedToSectionsFeeder(action.payload.item))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* addFeedToSectionsFeederSaga() {
  yield takeEvery(REQUEST_ADD_FEED_TO_SECTIONS_FEEDER, addFeedToSectionsFeeder)
}

export const requestRemoveFeedFromSectionsFeeder = payload => {
  return {
    type: REQUEST_REMOVE_FEED_FROM_SECTIONS_FEEDER,
    payload
  }
}

export const receiveRemoveFeedFromSectionsFeeder = payload => {
  return {
    type: RECEIVE_REMOVE_FEED_FROM_SECTIONS_FEEDER,
    payload
  }
}

function* removeFeedFromSectionsFeeder(action) {
  const url = rootApi + 'account/remove-from-my-home-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    yield call([axios, 'post'], url, params, {
      headers,
      cancelToken: source.token
    })
    yield put(receiveRemoveFeedFromSectionsFeeder(action.payload.item))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* removeFeedFromSectionsFeederSaga() {
  yield takeEvery(REQUEST_REMOVE_FEED_FROM_SECTIONS_FEEDER, removeFeedFromSectionsFeeder)
}

export const requestFeedsSavedToSectionsFeeder = payload => {
  return {
    type: REQUEST_FEEDS_SAVED_TO_SECTIONS_FEEDER,
    payload
  }
}

export const receiveFeedsSavedToSectionsFeeder = payload => {
  return {
    type: RECEIVE_FEEDS_SAVED_TO_SECTIONS_FEEDER,
    payload
  }
}

function* feedsSavedToSectionsFeeder(action) {
  const url = rootApi + 'account/get-my-home-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    feed_id: payload.feedId
  }
  const headers = getHeaders(token)

  try {
    const response = yield call([axios, 'get'], url, {
      headers,
      params
    })
    const formattedFeedSections = response.data.feeds.reduce((acc, item) => {
      acc.push({
        text: item.name,
        to: '/custom-feed/' + item.id + '----' + item.name,
        id: item.id
      })
      return acc
    }, [])
    yield put(receiveFeedsSavedToSectionsFeeder(formattedFeedSections))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* FeedsSavedToSectionsFeederSaga() {
  yield takeEvery(REQUEST_FEEDS_SAVED_TO_SECTIONS_FEEDER, feedsSavedToSectionsFeeder)
}

export const requestRetrieveImageFirstItem = payload => {
  return {
    type: REQUEST_RETRIEVE_IMAGE_FIRST_ITEM,
    payload
  }
}

const receiveRetrieveImageFirstItem = payload => {
  return {
    type: RECEIVE_RETRIEVE_IMAGE_FIRST_ITEM,
    payload
  }
}

function* getImageFirstItem(action) {
  if (action.payload.search_parameters !== null) {
    const url = rootApi + 'account/advanced-search'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')

    const params = {
      ...action.payload.search_parameters,
      start: (action.payload.search_parameters && action.payload.search_parameters.start) || 0,
      limit: (action.payload.search_parameters && action.payload.search_parameters.limit) || 10
      // type: (action.payload.search_parameters && action.payload.search_parameters.type) || undefined
    }
    const headers = getHeaders(token)
    const response = yield call([axios, 'post'], url, params, headers)
    const firstResponseNoTags =
      response.data.hits &&
      response.data.hits.filter(item => {
        return item.item_type !== 'tags'
      })[0]
    const thumbnail = firstResponseNoTags && firstResponseNoTags.thumbnail

    yield put(receiveRetrieveImageFirstItem({ thumbnail, id: action.payload.id }))
  } else if (!action.payload.search_parameters) {
    const url = rootApi + 'deck/get-recent-picks'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    const parametersURL = action.payload.feed_url
      ? queryString.parseUrl(action.payload.feed_url)
      : queryString.parseUrl(action.payload.url)

    const params = {
      limit: 1,
      media_tags: parametersURL.query['mediaTags[0]'],
      picked_by: parametersURL.query.pickedBy,
      sorting: parametersURL.query.sorting
    }

    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      cancelToken: source.token,
      params
    })

    const thumbnail2 = response.data.picks[0] && response.data.picks[0].thumbnail

    yield put(receiveRetrieveImageFirstItem({ thumbnail: thumbnail2, id: action.payload.id }))
  }
}

function* retrieveImageFirstItemSaga() {
  yield takeEvery(REQUEST_RETRIEVE_IMAGE_FIRST_ITEM, getImageFirstItem)
}

export function updateSortFeedsSectionsProfile(payload) {
  return {
    type: UPDATE_SORT_FEEDS_SECTIONS_PROFILE,
    payload
  }
}

export const requestSaveSectionFeedsOrder = payload => {
  return {
    type: REQUEST_SAVE_SECTION_FEEDS_ORDER,
    payload
  }
}

export const receiveSaveSectionFeedsOrder = payload => {
  return {
    type: RECEIVE_SAVE_SECTION_FEEDS_ORDER,
    payload
  }
}

function* saveSectionFeedsOrder(action) {
  const url = rootApi + 'account/bulk-change-my-feeds-order'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')

  const response = yield call(
    [axios, 'post'],
    url,
    {
      feed_ids: action.payload.feedsIds
    },
    {
      headers: getHeaders(token)
    }
  )
  yield put(receiveSaveSectionFeedsOrder(response))
}

function* saveSectionFeedsOrderSaga() {
  yield takeEvery(REQUEST_SAVE_SECTION_FEEDS_ORDER, saveSectionFeedsOrder)
}

export const requestSetFeedThumbnails = payload => {
  return {
    type: 'REQUEST_SET_FEED_THUMBNAILS',
    payload
  }
}

export const receiveSetFeedThumbnails = payload => {
  return {
    type: 'RECEIVE_SET_FEED_THUMBNAILS',
    payload
  }
}

function* getFeedThumbnails(action) {
  if (action.payload.search_parameters !== null) {
    const url = rootApi + 'account/advanced-search'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')
    const params = {
      ...action.payload.search_parameters,
      start: (action.payload.search_parameters && action.payload.search_parameters.start) || 0,
      limit: 4,
      type: (action.payload.search_parameters && action.payload.search_parameters.type) || ''
    }
    const headers = getHeaders(token)
    const response = yield call([axios, 'post'], url, params, headers)
    const thumbnails =
      response.data.hits &&
      response.data.hits
        .filter(item => {
          return item.item_type !== 'tags'
        })
        .reduce((acc, item) => {
          acc.push(item.thumbnail)
          return acc
        }, [])
    yield put(receiveRetrieveImageFirstItem({ thumbnails, id: action.payload.id }))
  } else if (!action.payload.search_parameters) {
    const url = rootApi + 'deck/get-recent-picks'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    const params = {
      limit: 4,
      media_tags: action.payload.query.object['mediaTags[0]'],
      picked_by: action.payload.query.object.pickedBy,
      sorting: action.payload.query.object.sorting
    }

    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      cancelToken: source.token,
      params
    })
    const thumbnails = response.data.picks.reduce((acc, item) => {
      acc.push(item.thumbnail)
      return acc
    }, [])
    yield put(receiveSetFeedThumbnails({ thumbnails, id: action.payload.id }))
  }
}

function* setFeedThumbnailsSaga() {
  yield takeEvery(REQUEST_SET_FEED_CHILDREN, getFeedThumbnails)
}

export const requestSetFeedChildren = payload => {
  return {
    type: REQUEST_SET_FEED_CHILDREN,
    payload
  }
}

export const receiveSetFeedChildren = payload => {
  return {
    type: RECEIVE_SET_FEED_CHILDREN,
    payload
  }
}

function* getFeedChildren(action) {
  if (action.payload.search_parameters !== null) {
    const url = rootApi + 'account/advanced-search'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')
    const params = {
      ...action.payload.search_parameters,
      start: (action.payload.search_parameters && action.payload.search_parameters.start) || 0,
      limit: 4,
      type: (action.payload.search_parameters && action.payload.search_parameters.type) || ''
    }
    const headers = getHeaders(token)
    const response = yield call([axios, 'post'], url, params, headers)
    const children =
      response.data.hits &&
      response.data.hits
        .filter(item => {
          return item.item_type !== 'tags'
        })
        .reduce((acc, item) => {
          acc.push(item.id)
          return acc
        }, [])
    yield put(receiveSetFeedChildren({ children, id: action.payload.id }))
  } else if (!action.payload.search_parameters) {
    const url = rootApi + 'deck/get-recent-picks'
    const user = yield select(selectUser)
    const token = get(user, 'data.auth_token')
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    const params = {
      limit: 4,
      media_tags: action.payload.query.object['mediaTags[0]'],
      picked_by: action.payload.query.object.pickedBy,
      sorting: action.payload.query.object.sorting
    }

    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      cancelToken: source.token,
      params
    })
    const children = response.data.picks.reduce((acc, item) => {
      acc.push(item.id)
      return acc
    }, [])
    yield put(receiveSetFeedChildren({ children, id: action.payload.id }))
  }
}

function* setFeedChildrenSaga() {
  yield takeEvery(REQUEST_SET_FEED_CHILDREN, getFeedChildren)
}

export const requestSaveEditNewSection = payload => {
  return {
    type: REQUEST_SAVE_EDIT_NEW_SECTION,
    payload
  }
}

export const receiveSaveEditNewSection = data => {
  return {
    type: RECEIVE_SAVE_EDIT_NEW_SECTION,
    payload: {
      data
    }
  }
}

function* saveNewEditSection(action) {
  const url = rootApi + 'custom-feed/create-or-update-section'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const params = {
    feed_section_id: action.payload.feed_id || undefined,
    home: true,
    name: action.payload.name,
    position: 0
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }

  try {
    const response = yield call([axios, 'post'], url, params, {
      headers: headers,
      cancelToken: source.token
    })
    yield put(receiveSaveEditNewSection(response))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* saveNewEditSectionSaga() {
  yield takeEvery(REQUEST_SAVE_EDIT_NEW_SECTION, saveNewEditSection)
}

export const requestCustomFeedSections = payload => {
  return {
    type: REQUEST_CUSTOM_FEED_SECTIONS,
    payload
  }
}

export const receiveCustomFeedSections = payload => {
  return {
    type: RECEIVE_CUSTOM_FEED_SECTIONS,
    payload
  }
}

function* getCustomFeedSections(action) {
  const url = rootApi + 'account/get-feed-sections'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { payload = {} } = action
  const params = {
    home: payload.home,
    user_id: payload.userId,
    include_empty: 0
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }
  if (token) {
    headers['Authentication-Token'] = token
  }

  try {
    const response = yield call([axios, 'get'], url, {
      headers,
      params
    })

    yield put(receiveCustomFeedSections(response.data.sections))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* customFeedSectionsSaga() {
  yield takeEvery(REQUEST_CUSTOM_FEED_SECTIONS, getCustomFeedSections)
}

export const requestUpdateSortCustomFeedSections = payload => {
  return {
    type: REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTIONS,
    payload
  }
}

export const receiveUpdateSortCustomFeedSections = payload => {
  return {
    type: RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTIONS,
    payload
  }
}

function* updateSortCustomFeedSections(action) {
  const items = action.payload.sections.reduce((acc, item) => {
    acc.push(item.id)
    return acc
  }, [])
  const element = items[action.payload.oldIndex]
  items.splice(action.payload.oldIndex, 1)
  items.splice(action.payload.newIndex, 0, element)
  yield put(receiveUpdateSortCustomFeedSections(action))

  const url = rootApi + 'custom-feed/reorder-sections'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const params = {
    feed_section_ids: items
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }

  try {
    yield call([axios, 'post'], url, params, {
      headers: headers,
      cancelToken: source.token
    })
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* updateSortCustomFeedSectionsSaga() {
  yield takeEvery(REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTIONS, updateSortCustomFeedSections)
}

export const requestUpdateSortCustomFeedSection = payload => {
  return {
    type: REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTION,
    payload
  }
}

export const sortCustomFeedSection = payload => {
  return {
    type: RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTION,
    payload
  }
}

function* updateSortCustomFeedSection(action) {
  const feeds = action.payload.feeds
  const feedsIds = feeds.map(item => item.id)
  const url = rootApi + 'custom-feed/reorder-section-feeds'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const params = {
    feed_ids: feedsIds,
    feed_section_id: action.payload.id
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }

  try {
    yield call([axios, 'post'], url, params, {
      headers: headers,
      cancelToken: source.token
    })
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* updateSortCustomFeedSectionSaga() {
  yield takeEvery(REQUEST_UPDATE_SORT_CUSTOM_FEED_SECTION, updateSortCustomFeedSection)
}

export const requestAddFeedToFeedSection = payload => {
  return {
    type: REQUEST_ADD_FEED_TO_FEED_SECTION,
    payload
  }
}

export const receiveAddFeedToFeedSection = payload => {
  return {
    type: RECEIVE_ADD_FEED_TO_FEED_SECTION,
    payload
  }
}

function* addFeedToFeedSection(action) {
  const url = rootApi + 'custom-feed/add-feed-to-section'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const params = {
    feed_id: action.payload.feedId,
    feed_section_id: action.payload.feedSectionId
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }

  try {
    const response = yield call([axios, 'post'], url, params, {
      headers: headers,
      cancelToken: source.token
    })
    yield put(receiveAddFeedToFeedSection(response))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* addFeedToFeedSectionSaga() {
  yield takeEvery(REQUEST_ADD_FEED_TO_FEED_SECTION, addFeedToFeedSection)
}

export const requestRemoveFeedToFeedSection = payload => {
  return {
    type: REQUEST_REMOVE_FEED_TO_FEED_SECTION,
    payload
  }
}

export const receiveRemoveFeedToFeedSection = payload => {
  return {
    type: RECEIVE_REMOVE_FEED_FROM_FEED_SECTION,
    payload
  }
}

function* removeFeedToFeedSection(action) {
  const url = rootApi + 'custom-feed/remove-feed-from-section'
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const params = {
    feed_id: action.payload.feedId,
    feed_section_id: action.payload.feedSectionId
  }
  const headers = {
    Accept: 'application/json',
    'Authentication-Token': token,
    'Content-Type': 'application/json'
  }

  try {
    const response = yield call([axios, 'post'], url, params, {
      headers: headers,
      cancelToken: source.token
    })
    yield put(receiveRemoveFeedToFeedSection(response))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* removeFeedToFeedSectionSaga() {
  yield takeEvery(REQUEST_REMOVE_FEED_TO_FEED_SECTION, removeFeedToFeedSection)
}

export const sagas = [
  getFeedSectionsSaga,
  addFeedToSectionsProfileSaga,
  removeFeedFromSectionsProfileSaga,
  FeedsSavedToSectionsProfileSaga,
  addFeedToSectionsFeederSaga,
  removeFeedFromSectionsFeederSaga,
  FeedsSavedToSectionsFeederSaga,
  retrieveImageFirstItemSaga,
  saveSectionFeedsOrderSaga,
  setFeedThumbnailsSaga,
  setFeedChildrenSaga,
  saveNewEditSectionSaga,
  customFeedSectionsSaga,
  updateSortCustomFeedSectionsSaga,
  updateSortCustomFeedSectionSaga,
  addFeedToFeedSectionSaga,
  removeFeedToFeedSectionSaga
]
